import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-01-27T10:00:00-0500.
 */
export function useWorkOrderTenantSurveysEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.WorkOrderTenantSurveys, false);

  return Boolean(isEnabled);
}
